import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import Icon from '../AppIcon';
import Button from './Button';
import Input from './Input';

const DonationQuickAction = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [amount, setAmount] = useState('');
  const [selectedAmount, setSelectedAmount] = useState(null);
  const location = useLocation();

  const quickAmounts = [25, 50, 100, 250];

  const getContextualContent = () => {
    switch (location?.pathname) {
      case '/charity-profile':
        return {
          title: 'Donate Now',
          subtitle: 'Support this charity',
          icon: 'Heart'
        };
      case '/cause-discovery':
        return {
          title: 'Quick Donate',
          subtitle: 'Choose amount',
          icon: 'Zap'
        };
      default:
        return {
          title: 'Donate',
          subtitle: 'Make a difference',
          icon: 'Gift'
        };
    }
  };

  const handleAmountSelect = (value) => {
    setSelectedAmount(value);
    setAmount(value?.toString());
  };

  const handleCustomAmount = (e) => {
    const value = e?.target?.value;
    setAmount(value);
    setSelectedAmount(null);
  };

  const handleDonate = () => {
    if (amount && parseFloat(amount) > 0) {
      console.log('Processing donation:', amount);
      setIsExpanded(false);
      setAmount('');
      setSelectedAmount(null);
    }
  };

  const content = getContextualContent();

  return (
    <>
      {/* Desktop Floating Action Button */}
      <div className="hidden md:block fixed bottom-6 right-6 z-60">
        {isExpanded ? (
          <div className="bg-card border border-border rounded-lg shadow-elevation-3 p-6 w-80 animate-scale-in">
            <div className="flex items-center justify-between mb-4">
              <div>
                <h3 className="text-lg font-semibold text-card-foreground">{content?.title}</h3>
                <p className="text-sm text-muted-foreground">{content?.subtitle}</p>
              </div>
              <Button
                variant="ghost"
                size="sm"
                onClick={() => setIsExpanded(false)}
              >
                <Icon name="X" size={16} />
              </Button>
            </div>

            <div className="space-y-4">
              {/* Quick Amount Buttons */}
              <div className="grid grid-cols-2 gap-2">
                {quickAmounts?.map((value) => (
                  <Button
                    key={value}
                    variant={selectedAmount === value ? "default" : "outline"}
                    size="sm"
                    onClick={() => handleAmountSelect(value)}
                    className="font-mono"
                  >
                    ${value}
                  </Button>
                ))}
              </div>

              {/* Custom Amount Input */}
              <Input
                type="number"
                placeholder="Custom amount"
                value={amount}
                onChange={handleCustomAmount}
                className="font-mono"
              />

              {/* Donate Button */}
              <Button
                onClick={handleDonate}
                disabled={!amount || parseFloat(amount) <= 0}
                className="w-full"
                iconName="Heart"
                iconPosition="left"
              >
                Donate ${amount || '0'}
              </Button>
            </div>
          </div>
        ) : (
          <Button
            onClick={() => setIsExpanded(true)}
            size="lg"
            className="rounded-full w-14 h-14 shadow-elevation-2 hover:shadow-elevation-3 transition-gentle hover-scale"
          >
            <Icon name={content?.icon} size={24} />
          </Button>
        )}
      </div>
      {/* Mobile Inline Component */}
      <div className="md:hidden">
        {(location?.pathname === '/charity-profile' || location?.pathname === '/cause-discovery') && (
          <div className="bg-card border border-border rounded-lg p-4 m-4">
            <div className="flex items-center space-x-2 mb-3">
              <Icon name={content?.icon} size={20} className="text-primary" />
              <h3 className="font-semibold text-card-foreground">{content?.title}</h3>
            </div>

            <div className="space-y-3">
              {/* Quick Amount Buttons */}
              <div className="grid grid-cols-4 gap-2">
                {quickAmounts?.map((value) => (
                  <Button
                    key={value}
                    variant={selectedAmount === value ? "default" : "outline"}
                    size="sm"
                    onClick={() => handleAmountSelect(value)}
                    className="font-mono text-xs"
                  >
                    ${value}
                  </Button>
                ))}
              </div>

              {/* Custom Amount and Donate */}
              <div className="flex space-x-2">
                <Input
                  type="number"
                  placeholder="Amount"
                  value={amount}
                  onChange={handleCustomAmount}
                  className="flex-1 font-mono"
                />
                <Button
                  onClick={handleDonate}
                  disabled={!amount || parseFloat(amount) <= 0}
                  iconName="Heart"
                  iconPosition="left"
                >
                  Donate
                </Button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default DonationQuickAction;